export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeAllFirstChars(str: string) {
  return str.split(' ').map(capitalize).join(' ');
}

export function humanizeName(layout: string): string {
  return capitalizeAllFirstChars(humanizeNameLowercase(layout));
}

export function humanizeNameLowercase(layout: string): string {
  return layout.toLowerCase().replaceAll('_', ' ').replaceAll('-', ' ');
}

export function toSnakeCase<T extends string>(str: string): T {
  return str.replaceAll(' ', '_').replaceAll('-', '_') as T;
}

export function toKebabCase<T extends string>(str: string): T {
  return str.replaceAll(' ', '-').replaceAll('_', '-') as T;
}
